module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "follow-us"
  }, [_c('span', [_vm._v("Follow us")]), _vm._v(" "), _c('a', {
    staticClass: "facebook cur",
    attrs: {
      "href": "https://www.facebook.com/craitapp/",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "twitter cur",
    attrs: {
      "href": "https://twitter.com/craitapp?lang=e",
      "target": "_blank"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © Crait Corp. All Rights Reserved.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-451fbe4b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 258
// module chunks = 1